import { useState } from "react";
import { X } from "lucide-react";
import api, { formatError } from "../../lib/api";
import { toast } from "sonner";

export default function RequestQuoteModal({ wine, mode = "quote", onClose }) {
    const isSample = mode === "sample";
    const [form, setForm] = useState({
        importer_name: "",
        importer_company: "",
        importer_email: "",
        country: "",
        quantity: isSample ? 1 : 100,
        message: isSample ? "Sample request — please send 1 bottle for tasting evaluation." : "",
    });
    const [submitting, setSubmitting] = useState(false);

    if (!wine) return null;

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post("/quote-requests", { wine_id: wine.id, ...form, quantity: Number(form.quantity) });
            toast.success(isSample ? "Sample request sent. The winery will arrange shipment." : "Quote request sent. The winery will contact you shortly.");
            onClose();
        } catch (err) {
            toast.error(formatError(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in" data-testid="quote-modal">
            <div className="bg-[#0A0A0A] border border-[#27272A] max-w-xl w-full max-h-[90vh] overflow-y-auto">
                <div className="flex items-start justify-between p-8 border-b border-[#27272A]">
                    <div>
                        <p className="overline mb-2">{isSample ? "Request Sample" : "Request Quote"}</p>
                        <h3 className="font-display text-3xl">{wine.name}</h3>
                        <p className="text-sm text-[#A1A1AA] mt-1">{wine.winery_name} · {wine.vintage}</p>
                    </div>
                    <button onClick={onClose} className="text-[#71717A] hover:text-white" data-testid="quote-modal-close">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <form onSubmit={submit} className="p-8 space-y-6">
                    <div className="grid md:grid-cols-2 gap-6">
                        <input required className="input-line" placeholder="Your Name" data-testid="quote-name" value={form.importer_name} onChange={(e) => setForm({ ...form, importer_name: e.target.value })} />
                        <input required className="input-line" placeholder="Company" data-testid="quote-company" value={form.importer_company} onChange={(e) => setForm({ ...form, importer_company: e.target.value })} />
                        <input required type="email" className="input-line" placeholder="Email" data-testid="quote-email" value={form.importer_email} onChange={(e) => setForm({ ...form, importer_email: e.target.value })} />
                        <input required className="input-line" placeholder="Country" data-testid="quote-country" value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} />
                        <input required type="number" min="1" className="input-line md:col-span-2" placeholder="Quantity (cases)" data-testid="quote-quantity" value={form.quantity} onChange={(e) => setForm({ ...form, quantity: e.target.value })} />
                    </div>
                    <textarea
                        className="input-line resize-none"
                        rows="4"
                        placeholder="Tell the winery about your distribution market, target volume, timeline..."
                        data-testid="quote-message"
                        value={form.message}
                        onChange={(e) => setForm({ ...form, message: e.target.value })}
                    />
                    <button type="submit" disabled={submitting} className="btn-gold w-full" data-testid="quote-submit">
                        {submitting ? "Sending..." : "Send Request"}
                    </button>
                </form>
            </div>
        </div>
    );
}
